import { LanguageModel } from './language.model';

// Same as the iso languages in src\app\Common\Forms\data\iso-language-names.ts
export const availableLanguages: LanguageModel[] = [
    new LanguageModel('aa'),
    new LanguageModel('ab'),
    new LanguageModel('ae'),
    new LanguageModel('af'),
    new LanguageModel('ak'),
    new LanguageModel('am'),
    new LanguageModel('an'),
    new LanguageModel('ar'),
    new LanguageModel('as'),
    new LanguageModel('av'),
    new LanguageModel('ay'),
    new LanguageModel('az'),
    new LanguageModel('ba'),
    new LanguageModel('be'),
    new LanguageModel('bg'),
    new LanguageModel('bh'),
    new LanguageModel('bi'),
    new LanguageModel('bm'),
    new LanguageModel('bn'),
    new LanguageModel('bo'),
    new LanguageModel('br'),
    new LanguageModel('bs'),
    new LanguageModel('ca'),
    new LanguageModel('ce'),
    new LanguageModel('ch'),
    new LanguageModel('co'),
    new LanguageModel('cr'),
    new LanguageModel('cs'),
    new LanguageModel('cu'),
    new LanguageModel('cv'),
    new LanguageModel('cy'),
    new LanguageModel('da'),
    new LanguageModel('de'),
    new LanguageModel('dv'),
    new LanguageModel('dz'),
    new LanguageModel('ee'),
    new LanguageModel('el'),
    new LanguageModel('en'),
    new LanguageModel('eo'),
    new LanguageModel('es'),
    new LanguageModel('et'),
    new LanguageModel('eu'),
    new LanguageModel('fa'),
    new LanguageModel('ff'),
    new LanguageModel('fi'),
    new LanguageModel('fj'),
    new LanguageModel('fo'),
    new LanguageModel('fr'),
    new LanguageModel('fy'),
    new LanguageModel('ga'),
    new LanguageModel('gd'),
    new LanguageModel('gl'),
    new LanguageModel('gn'),
    new LanguageModel('gu'),
    new LanguageModel('gv'),
    new LanguageModel('ha'),
    new LanguageModel('he'),
    new LanguageModel('iw'),
    new LanguageModel('hi'),
    new LanguageModel('ho'),
    new LanguageModel('hr'),
    new LanguageModel('ht'),
    new LanguageModel('hu'),
    new LanguageModel('hy'),
    new LanguageModel('hz'),
    new LanguageModel('ia'),
    new LanguageModel('in'),
    new LanguageModel('ie'),
    new LanguageModel('ig'),
    new LanguageModel('ii'),
    new LanguageModel('ik'),
    new LanguageModel('io'),
    new LanguageModel('is'),
    new LanguageModel('it'),
    new LanguageModel('iu'),
    new LanguageModel('ja'),
    new LanguageModel('jv'),
    new LanguageModel('ka'),
    new LanguageModel('kg'),
    new LanguageModel('ki'),
    new LanguageModel('kj'),
    new LanguageModel('kk'),
    new LanguageModel('kl'),
    new LanguageModel('km'),
    new LanguageModel('kn'),
    new LanguageModel('ko'),
    new LanguageModel('kr'),
    new LanguageModel('ks'),
    new LanguageModel('ku'),
    new LanguageModel('kv'),
    new LanguageModel('kw'),
    new LanguageModel('ky'),
    new LanguageModel('la'),
    new LanguageModel('lb'),
    new LanguageModel('lg'),
    new LanguageModel('li'),
    new LanguageModel('ln'),
    new LanguageModel('lo'),
    new LanguageModel('lt'),
    new LanguageModel('lu'),
    new LanguageModel('lv'),
    new LanguageModel('mg'),
    new LanguageModel('mh'),
    new LanguageModel('mi'),
    new LanguageModel('mk'),
    new LanguageModel('ml'),
    new LanguageModel('mn'),
    new LanguageModel('mr'),
    new LanguageModel('ms'),
    new LanguageModel('mt'),
    new LanguageModel('my'),
    new LanguageModel('na'),
    new LanguageModel('nb'),
    new LanguageModel('nd'),
    new LanguageModel('ne'),
    new LanguageModel('ng'),
    new LanguageModel('nl'),
    new LanguageModel('nn'),
    new LanguageModel('no'),
    new LanguageModel('nr'),
    new LanguageModel('nv'),
    new LanguageModel('ny'),
    new LanguageModel('oc'),
    new LanguageModel('oj'),
    new LanguageModel('om'),
    new LanguageModel('or'),
    new LanguageModel('os'),
    new LanguageModel('pa'),
    new LanguageModel('pi'),
    new LanguageModel('pl'),
    new LanguageModel('ps'),
    new LanguageModel('pt'),
    new LanguageModel('qu'),
    new LanguageModel('rm'),
    new LanguageModel('rn'),
    new LanguageModel('ro'),
    new LanguageModel('ru'),
    new LanguageModel('rw'),
    new LanguageModel('sa'),
    new LanguageModel('sc'),
    new LanguageModel('sd'),
    new LanguageModel('se'),
    new LanguageModel('sg'),
    new LanguageModel('si'),
    new LanguageModel('sk'),
    new LanguageModel('sl'),
    new LanguageModel('sm'),
    new LanguageModel('sn'),
    new LanguageModel('so'),
    new LanguageModel('sq'),
    new LanguageModel('sr'),
    new LanguageModel('ss'),
    new LanguageModel('st'),
    new LanguageModel('su'),
    new LanguageModel('sv'),
    new LanguageModel('sw'),
    new LanguageModel('ta'),
    new LanguageModel('te'),
    new LanguageModel('tg'),
    new LanguageModel('th'),
    new LanguageModel('ti'),
    new LanguageModel('tk'),
    new LanguageModel('tl'),
    new LanguageModel('tn'),
    new LanguageModel('to'),
    new LanguageModel('tr'),
    new LanguageModel('ts'),
    new LanguageModel('tt'),
    new LanguageModel('tw'),
    new LanguageModel('ty'),
    new LanguageModel('ug'),
    new LanguageModel('uk'),
    new LanguageModel('ur'),
    new LanguageModel('uz'),
    new LanguageModel('ve'),
    new LanguageModel('vi'),
    new LanguageModel('vo'),
    new LanguageModel('wa'),
    new LanguageModel('wo'),
    new LanguageModel('xh'),
    new LanguageModel('yi'),
    new LanguageModel('yo'),
    new LanguageModel('za'),
    new LanguageModel('zh'),
    new LanguageModel('zu'),
];
